import React from 'react';
import {
  Box,
  Container,
  Flex,
  Text,
  Link,
  HStack,
  VStack,
  Heading,
  SimpleGrid
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { articleMetadata, articleNavGroups } from '../../articles/metadata';

const Footer = () => {
  return (
    <Box
      as="footer"
      py={10}
      mt={10}
      borderTop="1px solid"
      borderColor="border.subtle"
      bg="bg.surface"
    >
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={10} mb={10}>
          <VStack align="flex-start" spacing={4}>
            <Heading as="h4" size="md" color="text.primary">GPX to KML Converter</Heading>
            <Text color="text.muted" fontSize="sm">
              Free, private, and secure online conversion tool for all your GPS data needs. Convert GPX files to KML format instantly.
            </Text>
          </VStack>

          {articleNavGroups.map((group) => (
            <VStack key={group.heading} align="flex-start" spacing={3}>
              <Heading as="h4" size="sm" color="text.primary">{group.heading}</Heading>
              {group.slugs.map((slug) => (
                <Link
                  key={slug}
                  as={RouterLink}
                  to={`/articles/${slug}`}
                  fontSize="sm"
                  color="text.muted"
                  _hover={{ color: 'brand.primary' }}
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {articleMetadata[slug].navTitle}
                </Link>
              ))}
            </VStack>
          ))}
        </SimpleGrid>

        <Box borderTop="1px solid" borderColor="border.subtle" pt={6}>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
            textAlign={{ base: 'center', md: 'left' }}
            gap={4}
          >
            <HStack spacing={1.5} fontSize="sm" color="text.muted">
              <Text>Made with</Text>
              <Text color="brand.primary">♥</Text>
              <Text>for the trails — Derek Meuwissen</Text>
            </HStack>
            <Link
              href="mailto:derekmeuwissen@gmail.com"
              fontSize="sm"
              color="text.muted"
              _hover={{ color: 'brand.primary' }}
              transition="color 0.2s ease"
            >
              derekmeuwissen@gmail.com
            </Link>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
